{
  "error": "Errore",
  "loading": "...",
  "newUser": "Nuovo utente",
  "newUserGroup": "Nuovo gruppo"
}
